import { render } from "./rematricula.vue?vue&type=template&id=b096ffe0"
import script from "./rematricula.vue?vue&type=script&lang=js"
export * from "./rematricula.vue?vue&type=script&lang=js"

import "./rematricula.vue?vue&type=style&index=0&id=b096ffe0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__